const identity = val => val;

const {
  trim,
  round
} = require('lodash');

const geoPoint = arr => {
  if (!arr) return arr;
  return arr.map(p => round(p, 5));
};

const geoShape = arr => {
  if (!arr) return arr;
  return arr.map(geoPoint);
}; // noinspection SpellCheckingInspection


module.exports = {
  json: any => JSON.stringify(any),
  strList: arr => JSON.stringify(arr),
  strinct: str => str == null || trim(str) === '' ? undefined : str,
  // nullable is a hof because it needs access to the original value, like nullable(strinct)(value)
  // We treat '' as a special case because that's what you get when you try to clear a form field
  nullable: (serializer = identity) => val => {
    if (val === undefined) return serializer(val);
    return trim(val) === '' || val === null ? null : serializer(val);
  },
  trim,
  geoPoint,
  geoShape,
  polygon: arr => {
    if (!arr) return arr;
    return arr.map(geoShape);
  }
};